import { create } from 'zustand';

type UrlValidationState = {
  isPending: boolean;
  setIsPending: (isPending: boolean) => void;
};

const useUrlValidationStore = create<UrlValidationState>((set) => ({
  isPending: false,
  setIsPending: (isPending: boolean) => set({ isPending }),
}));

export default useUrlValidationStore;
